(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar-menu/components/top-bar-tabs.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar-menu/components/top-bar-tabs.js');
"use strict";

const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
setGlobal('svs.ticketgames.ticketScratch.components.topBar.topBarMenu.TopBarTabs', _ref => {
  let {
    spelguides,
    setActiveTab
  } = _ref;
  return React.createElement(ItemsMenu, {
    branding: "tur",
    inverted: true
  }, spelguides.map((_ref2, i) => {
    let {
      tabName,
      active
    } = _ref2;
    return React.createElement(LinkItem, {
      className: "fc-white ts-top-bar-tab ".concat(active && 'ts-top-bar-tab-active'),
      Component: "a",
      "data-id": tabName,
      "data-tab": i,
      href: "",
      key: "".concat(tabName + i),
      label: tabName,
      onClick: e => setActiveTab(e, {
        tabName
      }),
      selected: active
    });
  }));
});

 })(window);